import React from 'react'
import "./cryptocommand.scss";
const Cryptocommand = () => {
    return (
        <>
            <section className='cryptocomandsprnt'>

                <div className="custom-container">
                    <div className="ourstorychldprnt">
                        <div className="storyprnt">
                            <div className="rightimgprnt">
                                <img className='img-fluid' src="\assets\Wallet\cryptocomandimg.png" alt="ourstoryimg" />
                            </div>
                            <div className="aboutusmission">
                                {/* <h5 ref={buttonRef}>Who We Are</h5> */}
                                <div className="aboutusmissioncnt">
                                    <h3>Crypto at Your Command</h3>
                                    <p >TOMI Wallet lets you manage digital assets hands-free with the first AI-powered voice assistant for crypto. Just say a command—no screens, no friction.</p>
                                    <div className="cryptocomandcnt">

                                        <p ><span>Send funds instantly:</span> "Send 500 USDT to John on Ethereum."</p>
                                        <p><span>Coming Soon:</span> Swap tokens, check balances & view history</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


        </>
    )
}

export default Cryptocommand